module.exports = __webpack_public_path__ + "assets/public/imgs/openshift-dedicated-logo.svg";